//= require bijou/cjs_shim
//= require jquery/dist/jquery
//= require bijou/smart_form

require('jquery')
require('./bijou/smart_form')

;(function ($) {
  'use strict'

  $.bijou = $.bijou || {}

  $.extend($.bijou, {
    defaults: {
      apply_modules: true,
      smarten_forms: true
    },

    ajaxInited: false,

    init: function (opts) {
      var _this = this

      this.options = $.extend(this.defaults, opts)
      $.bijou.enhance(document.documentElement)

      if (!this.ajaxInited) {
        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
          if (!options.crossDomain) {
            return _this.addCSRFToken(jqXHR)
          }
        })

        this.ajaxInited = true
      }
    },

    addCSRFToken: function (jqXHR) {
      var tokenMetaTag = $('meta[name="csrf-token"]')
      if (tokenMetaTag.length && tokenMetaTag.attr('content')) {
        jqXHR.setRequestHeader('X-CSRF-Token', tokenMetaTag.attr('content'))
      }
      return jqXHR
    },

    enhance: function (root) {
      root = $(root)

      if (this.options.smarten_forms) {
        this.smarten_forms(root)
      }

      if (this.options.apply_modules) {
        this.apply_modules(root)
      }

      root.trigger('bijou_init')
    },

    apply_modules: function (root) {
      root.find('[data-module]').each(function (index, element) {
        var $element = $(element)
        var modules = $element.data('module')

        $($.trim(modules).split(' ')).each(function (index, module) {
          if ($.fn[module]) {
            $element[module]()
          }
        })
      })
    },

    smarten_forms: function (root) {
      root.find('form:not([data-smart-form-disabled])').each(function (index, element) {
        var form = $(element)
        var customForm = form.data('smartForm')

        if (customForm && $.fn[customForm]) {
          form[customForm]()
        } else {
          form.smart_form()
        }
      })
    }
  })
}(window.jQuery))
